module.exports = __webpack_public_path__ + "img/hr-red-croton-14.c5a8bc53.png";